const STORAGE_KEY = 'transport-order-draft-v1'
let memory = null
let revision = 0

export const orderDraftFields = [
  'orderForm', 'shippingArea', 'autoReferenceNo', 'autoReferenceToken',
  'pieceWeightUnit', 'pieceDimensionUnit', 'selectedProductCodes', 'productTreeDefaults',
  'productSelectionTouched', 'selectedContactId', 'selectedSenderContactId',
  'selectedPackageTemplateId', 'senderExpanded', 'recipientRecognitionOpen',
  'recipientRecognitionText', 'recipientCities', 'recipientCityAddresses', 'recipientZipLookupKey'
]

export function isCreateOrderPath (path) {
  return String(path || '').split(/[?#]/)[0].replace(/\/$/, '').endsWith('/tr-create')
}

export function orderDraftRevision () { return revision }

export function readOrderDraft (owner) {
  try {
    const stored = typeof window !== 'undefined' && window.sessionStorage.getItem(STORAGE_KEY)
    const draft = stored ? JSON.parse(stored) : memory
    if (!draft || draft.owner !== owner || !draft.state || !draft.state.orderForm || !Array.isArray(draft.state.orderForm.payload.pieces)) return null
    return JSON.parse(JSON.stringify(draft.state))
  } catch (error) {
    return memory && memory.owner === owner ? JSON.parse(JSON.stringify(memory.state)) : null
  }
}

export function writeOrderDraft (owner, state, expectedRevision) {
  if (!owner || expectedRevision !== revision) return
  memory = JSON.parse(JSON.stringify({ owner, state }))
  try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(memory)) } catch (error) { /* Retain navigation drafts when browser storage is unavailable. */ }
}

export function clearOrderDraft () {
  revision++
  memory = null
  try { window.sessionStorage.removeItem(STORAGE_KEY) } catch (error) { /* Storage may be disabled. */ }
}
